module.exports = __webpack_public_path__ + "img/DataObjectOutlined.8aa53e90.svg";